import http from '@/utils/http.js'

/*
 * @DESC:api接口
 */
const 	GET_FANS_COUNT = "/api/getFansCount",//粉丝统计
		GET_FANS_LIST = "/api/getFansList", //粉丝列表
		GET_FANS_ANALYSIS = "/api/getFansAnalysis"; //粉丝分析
		
export default {
	getFansList: async({
		commit
	}, params={}) => {
		const data = await http.get(GET_FANS_LIST,params)
		commit('GET_FANS_LIST', data)
	},
	getFansCount: async({
		commit
	}, params={}) => {
		const data = await http.get(GET_FANS_COUNT)
		commit('GET_FANS_COUNT', data)
	},
	getFansAnalysis: async({
		commit
	}, params={}) => {
		try{
			const data = await http.get(GET_FANS_ANALYSIS,params)
			commit('GET_FANS_ANALYSIS', data)
		}catch(e){
			throw e
		}
	},
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/fans/actions.js